import { ApplicationState } from '../../../../../store/types';
import { getAIChatbotRoot } from '../../store';
import { CustomDocumentQueryAnalytics } from './types';

export const getIsFetchingCustomQueryAnalytics = (state: ApplicationState): boolean => getAIChatbotRoot(state).isFetchingCustomQueryAnalytics;

export const getCustomDocumentQueryAnalytics = (state: ApplicationState): CustomDocumentQueryAnalytics => getAIChatbotRoot(state).customDocumentQueryAnalytics;
